import templateUrl from './contact-additional.tpl.html';

angular
    .module('festzelt-os.contacts')
    .component('contactAdditional', {
        bindings: {
            contact: '=',
        },
        controller() {
            this.$onInit = () => {
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/additional/contact-additional.js